import React, { useState, useEffect } from 'react';
import { Crisp } from "crisp-sdk-web"
import { useHistory } from "react-router-dom";
import { Auth } from '../utils/amplifyWrapper';
import * as Sentry from '@sentry/react';
import { LogOut, User } from 'lucide-react';
import { Dropdown, DropdownItem, DropdownDivider, DropdownSection, DropdownText } from './ui/bootstrap';

function Avatar() {
    const [attr, setAttr] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        Auth.currentAuthenticatedUser({ bypassCache: true })
            .then(user => { setAttr(user.attributes); })
            .catch(err => { Sentry.captureException(err); })
            .finally(() => { setIsLoading(false); });
    }, []);

    const initials = attr?.given_name ? attr.given_name.charAt(0).toUpperCase() : '?';
    const hasCustomAvatar = attr?.hasOwnProperty?.('custom:avatar');

    const trigger = (
        <button
            type="button"
            style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
            }}
        >
            {isLoading ? (
                <div className="shine rounded-circle" style={{ width: 32, height: 32, flexShrink: 0 }} />
            ) : (
                <div
                    style={{
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        background: hasCustomAvatar
                            ? `url(${encodeURI(attr['custom:avatar'])}) center/cover no-repeat`
                            : 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-secondary) 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 12,
                        fontWeight: 700,
                        color: '#fff',
                        flexShrink: 0,
                    }}
                >
                    {!hasCustomAvatar && <span>{initials}</span>}
                </div>
            )}
        </button>
    );

    return (
        <Dropdown trigger={trigger} align="end">
            <DropdownSection label="Signed in as" />
            {attr?.email && <DropdownText>{attr.email}</DropdownText>}
            <DropdownDivider />
            <DropdownItem onClick={() => history.push('/profile')}>
                <User size={14} />
                Profile
            </DropdownItem>
            <DropdownDivider />
            <DropdownItem
                onClick={async () => {
                    Crisp.session.reset();
                    await Auth.signOut();
                    window.location.replace(window.location.origin);
                }}
                danger
            >
                <LogOut size={14} />
                Logout
            </DropdownItem>
        </Dropdown>
    );
}

export default Avatar;
